import styled from 'styled-components';

import COLORS from 'constants/colors';
import FONTS from 'constants/fonts';

const SignInDisclaimer = styled.div`
  margin-top: 8px;
  font-size: ${FONTS.P};
  color: ${COLORS.GRAY.GRAY_600};
  text-align: center;
`;

export default SignInDisclaimer;
